import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_date_pager = _resolveComponent("date-pager")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", null, "職員勤怠管理", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _ctx.exportMonthly,
        loading: _ctx.loading,
        color: "primary",
        variant: "flat",
        class: "mr-4"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" 月次帳票出力 ", -1)
        ]))]),
        _: 1
      }, 8, ["onClick", "loading"]),
      _createVNode(_component_v_btn, {
        onClick: _ctx.exportDaily,
        loading: _ctx.loading,
        color: "primary",
        variant: "flat",
        class: "mr-4"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" 日次帳票出力 ", -1)
        ]))]),
        _: 1
      }, 8, ["onClick", "loading"]),
      _createVNode(_component_v_btn, {
        onClick: _ctx.searchAttendance,
        loading: _ctx.loading,
        color: "primary",
        variant: "outlined"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("mdi-sync", -1)
            ]))]),
            _: 1
          }),
          _cache[5] || (_cache[5] = _createTextVNode(" 更新 ", -1))
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_date_pager, {
          modelValue: _ctx.searchFilters.date,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilters.date) = $event)),
          class: "pt-4",
          onInput: _ctx.pageClick
        }, null, 8, ["modelValue", "onInput"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      variant: "flat",
      class: "mt-4 pa-2",
      color: "grey-lighten-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("h5", null, "クラス", -1)),
                _createVNode(_component_v_select, {
                  modelValue: _ctx.searchFilters.classId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilters.classId) = $event)),
                  items: _ctx.classes,
                  "item-title": (item) => `(${item.year}) ${item.className}`,
                  "item-value": "classId",
                  variant: "outlined",
                  "hide-details": "auto",
                  density: "compact",
                  clearable: "",
                  disabled: _ctx.loading,
                  color: "primary"
                }, null, 8, ["modelValue", "items", "item-title", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.attendances)
      ? (_openBlock(), _createBlock(_component_v_table, {
          key: 0,
          class: "pt-4"
        }, {
          default: _withCtx(() => [
            _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "text-left" }, "職員氏名"),
                _createElementVNode("th", { class: "text-left" }, "勤怠状況"),
                _createElementVNode("th", { class: "text-left" }, "担任クラス"),
                _createElementVNode("th", { class: "text-left" }, "出勤時刻"),
                _createElementVNode("th", { class: "text-left" }, "退勤時刻"),
                _createElementVNode("th", { class: "text-left" })
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendances, (a) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: a.nurseryUser.userId
                }, [
                  _createElementVNode("td", null, _toDisplayString(a.nurseryUser.lastName) + " " + _toDisplayString(a.nurseryUser.firstName), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.getStatusText(a.status)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.getClassName(a.nurseryClasses)), 1),
                  _createElementVNode("td", null, _toDisplayString(a.attendedAt ? _ctx.formatDate(a.attendedAt) : "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(a.leftAt ? _ctx.formatDate(a.leftAt) : "-"), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "outlined",
                      small: "",
                      disabled: _ctx.loading,
                      to: `/staffAttendance/${a.nurseryUser.userId}/${_ctx.searchFilters.date}/edit`
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode(" 編集 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "to"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}